import axios from 'axios';
import { API_BASE_URI } from 'library/constants/api';

const API_BASE_URL = `${API_BASE_URI}/host/drafts`;

export interface ListingDraftSummary {
  draftId: string;
  title?: string | null;
  placeType?: string | null;
  resumePath: string;
  updatedAt?: string | null;
}

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('jwtToken')}` });

/** Unfinished "List it yourself" listings (saved before the property exists on the server). */
const DraftService = {
  save: async (data: {
    draftId?: string | null;
    title?: string;
    placeType?: string;
    resumePath: string;
    state: string;
  }): Promise<{ draftId: string }> => {
    const res = await axios.post(`${API_BASE_URL}/save`, data, { headers: auth() });
    return res.data;
  },

  list: async (): Promise<ListingDraftSummary[]> => {
    const res = await axios.get(`${API_BASE_URL}/list`, { headers: auth() });
    return Array.isArray(res.data) ? res.data : [];
  },

  get: async (draftId: string): Promise<{ draftId: string; resumePath: string; state: string }> => {
    const res = await axios.get(`${API_BASE_URL}/get`, { headers: auth(), params: { draftId } });
    return res.data;
  },

  remove: async (draftId: string): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/delete`, { headers: auth(), params: { draftId } });
  },
};

export default DraftService;
